// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO } from '../models';
import { OrganizationBrandingDTO } from '../models';
import { OrganizationBrandingEmailHeaderLogoUploadUrlDTO } from '../models';
import { OrganizationBrandingEmailPreviewDTO } from '../models';
import { PreviewOrganizationBrandingEmailDTO } from '../models';
import { UpsertOrganizationBrandingDTO } from '../models';
/**
 * OrganizationBrandingApi - axios parameter creator
 * @export
 */
export const OrganizationBrandingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a temporary upload URL for an organization branding email header logo.
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO} createOrganizationBrandingEmailHeaderLogoUploadUrlDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId: string, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling createOrganizationBrandingEmailHeaderLogoUploadUrl.');
            }
            // verify required parameter 'createOrganizationBrandingEmailHeaderLogoUploadUrlDTO' is not null or undefined
            if (createOrganizationBrandingEmailHeaderLogoUploadUrlDTO === null || createOrganizationBrandingEmailHeaderLogoUploadUrlDTO === undefined) {
                throw new RequiredError('createOrganizationBrandingEmailHeaderLogoUploadUrlDTO','Required parameter createOrganizationBrandingEmailHeaderLogoUploadUrlDTO was null or undefined when calling createOrganizationBrandingEmailHeaderLogoUploadUrl.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/branding/email-header-logo/upload-url`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createOrganizationBrandingEmailHeaderLogoUploadUrlDTO !== undefined ? createOrganizationBrandingEmailHeaderLogoUploadUrlDTO : {}) : (createOrganizationBrandingEmailHeaderLogoUploadUrlDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the internal organization branding profile database record.
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationBranding(organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling deleteOrganizationBranding.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/branding`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the internal organization branding profile.
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBranding(organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling getOrganizationBranding.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/branding`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview the internal organization branding email.
         * @param {string} organizationId Organization id
         * @param {PreviewOrganizationBrandingEmailDTO} previewOrganizationBrandingEmailDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOrganizationBrandingEmail(organizationId: string, previewOrganizationBrandingEmailDTO: PreviewOrganizationBrandingEmailDTO, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling previewOrganizationBrandingEmail.');
            }
            // verify required parameter 'previewOrganizationBrandingEmailDTO' is not null or undefined
            if (previewOrganizationBrandingEmailDTO === null || previewOrganizationBrandingEmailDTO === undefined) {
                throw new RequiredError('previewOrganizationBrandingEmailDTO','Required parameter previewOrganizationBrandingEmailDTO was null or undefined when calling previewOrganizationBrandingEmail.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/branding/email-preview`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PreviewOrganizationBrandingEmailDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(previewOrganizationBrandingEmailDTO !== undefined ? previewOrganizationBrandingEmailDTO : {}) : (previewOrganizationBrandingEmailDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or replace the internal organization branding profile.
         * @param {string} organizationId Organization id
         * @param {UpsertOrganizationBrandingDTO} upsertOrganizationBrandingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOrganizationBranding(organizationId: string, upsertOrganizationBrandingDTO: UpsertOrganizationBrandingDTO, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling upsertOrganizationBranding.');
            }
            // verify required parameter 'upsertOrganizationBrandingDTO' is not null or undefined
            if (upsertOrganizationBrandingDTO === null || upsertOrganizationBrandingDTO === undefined) {
                throw new RequiredError('upsertOrganizationBrandingDTO','Required parameter upsertOrganizationBrandingDTO was null or undefined when calling upsertOrganizationBranding.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/branding`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpsertOrganizationBrandingDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(upsertOrganizationBrandingDTO !== undefined ? upsertOrganizationBrandingDTO : {}) : (upsertOrganizationBrandingDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationBrandingApi - functional programming interface
 * @export
 */
export const OrganizationBrandingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a temporary upload URL for an organization branding email header logo.
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO} createOrganizationBrandingEmailHeaderLogoUploadUrlDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId: string, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationBrandingEmailHeaderLogoUploadUrlDTO> {
            const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete the internal organization branding profile database record.
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationBranding(organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).deleteOrganizationBranding(organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the internal organization branding profile.
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBranding(organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationBrandingDTO> {
            const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).getOrganizationBranding(organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Preview the internal organization branding email.
         * @param {string} organizationId Organization id
         * @param {PreviewOrganizationBrandingEmailDTO} previewOrganizationBrandingEmailDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOrganizationBrandingEmail(organizationId: string, previewOrganizationBrandingEmailDTO: PreviewOrganizationBrandingEmailDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationBrandingEmailPreviewDTO> {
            const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).previewOrganizationBrandingEmail(organizationId, previewOrganizationBrandingEmailDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create or replace the internal organization branding profile.
         * @param {string} organizationId Organization id
         * @param {UpsertOrganizationBrandingDTO} upsertOrganizationBrandingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOrganizationBranding(organizationId: string, upsertOrganizationBrandingDTO: UpsertOrganizationBrandingDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationBrandingDTO> {
            const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).upsertOrganizationBranding(organizationId, upsertOrganizationBrandingDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationBrandingApi - factory interface
 * @export
 */
export const OrganizationBrandingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a temporary upload URL for an organization branding email header logo.
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO} createOrganizationBrandingEmailHeaderLogoUploadUrlDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId: string, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options?: any) {
            return OrganizationBrandingApiFp(configuration).createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options)(axios, basePath);
        },
        /**
         * Delete the internal organization branding profile database record.
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationBranding(organizationId: string, options?: any) {
            return OrganizationBrandingApiFp(configuration).deleteOrganizationBranding(organizationId, options)(axios, basePath);
        },
        /**
         * Get the internal organization branding profile.
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBranding(organizationId: string, options?: any) {
            return OrganizationBrandingApiFp(configuration).getOrganizationBranding(organizationId, options)(axios, basePath);
        },
        /**
         * Preview the internal organization branding email.
         * @param {string} organizationId Organization id
         * @param {PreviewOrganizationBrandingEmailDTO} previewOrganizationBrandingEmailDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewOrganizationBrandingEmail(organizationId: string, previewOrganizationBrandingEmailDTO: PreviewOrganizationBrandingEmailDTO, options?: any) {
            return OrganizationBrandingApiFp(configuration).previewOrganizationBrandingEmail(organizationId, previewOrganizationBrandingEmailDTO, options)(axios, basePath);
        },
        /**
         * Create or replace the internal organization branding profile.
         * @param {string} organizationId Organization id
         * @param {UpsertOrganizationBrandingDTO} upsertOrganizationBrandingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertOrganizationBranding(organizationId: string, upsertOrganizationBrandingDTO: UpsertOrganizationBrandingDTO, options?: any) {
            return OrganizationBrandingApiFp(configuration).upsertOrganizationBranding(organizationId, upsertOrganizationBrandingDTO, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationBrandingApi - interface
 * @export
 * @interface OrganizationBrandingApi
 */
export interface OrganizationBrandingApiInterface {
    /**
     * Create a temporary upload URL for an organization branding email header logo.
     * @param {string} organizationId Organization id
     * @param {CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO} createOrganizationBrandingEmailHeaderLogoUploadUrlDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApiInterface
     */
    createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId: string, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options?: any): AxiosPromise<OrganizationBrandingEmailHeaderLogoUploadUrlDTO>;

    /**
     * Delete the internal organization branding profile database record.
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApiInterface
     */
    deleteOrganizationBranding(organizationId: string, options?: any): AxiosPromise<{}>;

    /**
     * Get the internal organization branding profile.
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApiInterface
     */
    getOrganizationBranding(organizationId: string, options?: any): AxiosPromise<OrganizationBrandingDTO>;

    /**
     * Preview the internal organization branding email.
     * @param {string} organizationId Organization id
     * @param {PreviewOrganizationBrandingEmailDTO} previewOrganizationBrandingEmailDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApiInterface
     */
    previewOrganizationBrandingEmail(organizationId: string, previewOrganizationBrandingEmailDTO: PreviewOrganizationBrandingEmailDTO, options?: any): AxiosPromise<OrganizationBrandingEmailPreviewDTO>;

    /**
     * Create or replace the internal organization branding profile.
     * @param {string} organizationId Organization id
     * @param {UpsertOrganizationBrandingDTO} upsertOrganizationBrandingDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApiInterface
     */
    upsertOrganizationBranding(organizationId: string, upsertOrganizationBrandingDTO: UpsertOrganizationBrandingDTO, options?: any): AxiosPromise<OrganizationBrandingDTO>;

}

/**
 * OrganizationBrandingApi - object-oriented interface
 * @export
 * @class OrganizationBrandingApi
 * @extends {BaseAPI}
 */
export class OrganizationBrandingApi extends BaseAPI implements OrganizationBrandingApiInterface {
    /**
     * Create a temporary upload URL for an organization branding email header logo.
     * @param {string} organizationId Organization id
     * @param {CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO} createOrganizationBrandingEmailHeaderLogoUploadUrlDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApi
     */
    public createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId: string, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options?: any) {
        return OrganizationBrandingApiFp(this.configuration).createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete the internal organization branding profile database record.
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApi
     */
    public deleteOrganizationBranding(organizationId: string, options?: any) {
        return OrganizationBrandingApiFp(this.configuration).deleteOrganizationBranding(organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Get the internal organization branding profile.
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApi
     */
    public getOrganizationBranding(organizationId: string, options?: any) {
        return OrganizationBrandingApiFp(this.configuration).getOrganizationBranding(organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Preview the internal organization branding email.
     * @param {string} organizationId Organization id
     * @param {PreviewOrganizationBrandingEmailDTO} previewOrganizationBrandingEmailDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApi
     */
    public previewOrganizationBrandingEmail(organizationId: string, previewOrganizationBrandingEmailDTO: PreviewOrganizationBrandingEmailDTO, options?: any) {
        return OrganizationBrandingApiFp(this.configuration).previewOrganizationBrandingEmail(organizationId, previewOrganizationBrandingEmailDTO, options)(this.axios, this.basePath);
    }

    /**
     * Create or replace the internal organization branding profile.
     * @param {string} organizationId Organization id
     * @param {UpsertOrganizationBrandingDTO} upsertOrganizationBrandingDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBrandingApi
     */
    public upsertOrganizationBranding(organizationId: string, upsertOrganizationBrandingDTO: UpsertOrganizationBrandingDTO, options?: any) {
        return OrganizationBrandingApiFp(this.configuration).upsertOrganizationBranding(organizationId, upsertOrganizationBrandingDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationBrandingApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a temporary upload URL for an organization branding email header logo.
 * @param {string} organizationId Organization id
 * @param {CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO} createOrganizationBrandingEmailHeaderLogoUploadUrlDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createOrganizationBrandingEmailHeaderLogoUploadUrl(
    organizationId: string,
    createOrganizationBrandingEmailHeaderLogoUploadUrlDTO: CreateOrganizationBrandingEmailHeaderLogoUploadUrlDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationBrandingEmailHeaderLogoUploadUrlDTO> {
    const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).createOrganizationBrandingEmailHeaderLogoUploadUrl(organizationId, createOrganizationBrandingEmailHeaderLogoUploadUrlDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete the internal organization branding profile database record.
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteOrganizationBranding(
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).deleteOrganizationBranding(organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get the internal organization branding profile.
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOrganizationBranding(
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationBrandingDTO> {
    const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).getOrganizationBranding(organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Preview the internal organization branding email.
 * @param {string} organizationId Organization id
 * @param {PreviewOrganizationBrandingEmailDTO} previewOrganizationBrandingEmailDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function previewOrganizationBrandingEmail(
    organizationId: string,
    previewOrganizationBrandingEmailDTO: PreviewOrganizationBrandingEmailDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationBrandingEmailPreviewDTO> {
    const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).previewOrganizationBrandingEmail(organizationId, previewOrganizationBrandingEmailDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create or replace the internal organization branding profile.
 * @param {string} organizationId Organization id
 * @param {UpsertOrganizationBrandingDTO} upsertOrganizationBrandingDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function upsertOrganizationBranding(
    organizationId: string,
    upsertOrganizationBrandingDTO: UpsertOrganizationBrandingDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationBrandingDTO> {
    const localVarAxiosArgs = OrganizationBrandingApiAxiosParamCreator(configuration).upsertOrganizationBranding(organizationId, upsertOrganizationBrandingDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

